// 'use client';

// import Image from 'next/image';
// import Link from 'next/link';
// import { useDictionary } from '@/core/hooks/use-dictionary';
// import { MainShopProduct } from '@/core/models/shop-product-model';
// import { formatPrice } from "@/utils/formatUtils"
// import { Heading } from '../../../../components/ui/Heading';
// import { Badge } from '../../../../components/ui/badge';
// import { Tooltip, TooltipContent, TooltipTrigger } from '../../../../components/ui/tooltip';
// export default function ProductCard({ product }: { product: MainShopProduct }) {
//   const { dictionary } = useDictionary();

//   return (
//     <Link
//       href={`/shop/product/${product.id}/${product.slug}`}
//       className="h-75 p-0 flex flex-col"
//     >
//       <div className="relative flex-1">
//         <Image
//           src={product.thumbnail.url}
//           alt={product.title}
//           fill
//           sizes="(max-width: 768px) 100vw, (max-width: 1200px) 33vw, 25vw"
//           className="object-contain"
//           priority
//         />
//         {product.discount_percent > 0 && <Badge variant="destructive" className="absolute top-2 right-2 ltr:left-2 text-xs rounded-xs">
//           {product.discount_percent + "% " + product.discount_title}
//         </Badge>}
//       </div>

//       <div className="p-2 space-y-2">
//         <Heading level={3} className="text-xs">
//           {product.title}
//         </Heading>
//         <div className="space-y-1">
//           {product.discount_percent > 0 ? (
//             <div className="flex items-center gap-2 flex-wrap">
//               <span className="text-xs text-red-500 line-through">
//                 {formatPrice(Number(product.price))} {dictionary.ui.product.currency}
//               </span>
//               <span className="text-primary-600 text-xs">
//                 {formatPrice(Number(product.final_price))} {dictionary.ui.product.currency}
//               </span>
//             </div>
//           ) : (
//             <span className="text-primary-600 text-xs">
//               {formatPrice(Number(product.price))} {dictionary.ui.product.currency}
//             </span>
//           )}
//         </div>
//         {!!product.product_colors && <div className="flex flex-wrap gap-3">
//           {product.product_colors.map((color, index) => (
//             <Tooltip key={index}>
//               <TooltipTrigger asChild>
//                 <span>
//                   <div
//                     className="size-4 rounded-full border border-primary-300 cursor-pointer hover:ring-2 hover:ring-[#C6B8A3] transition-transform hover:scale-110"
//                     style={{ backgroundColor: color.color_code_hex }}
//                     title={color.color_title}
//                   />
//                 </span>
//               </TooltipTrigger>
//               <TooltipContent>
//                 <p className="text-sm text-primary-0">{color.color_title}</p>
//               </TooltipContent>
//             </Tooltip>
//           ))}
//         </div>}
//       </div>
//     </Link>
//   );
// }



'use client';

import Image from 'next/image';
import Link from 'next/link';
import { useDictionary } from '@/core/hooks/use-dictionary';
import { MainShopProduct } from '@/core/models/shop-product-model';
import { formatPrice } from "@/utils/formatUtils"
import { Heading } from '../../../../components/ui/Heading';
import { Badge } from '../../../../components/ui/badge';
import { Tooltip, TooltipContent, TooltipTrigger } from '../../../../components/ui/tooltip';
import { getPackagingIcon } from '../../utils/productColorIcon';

export default function ProductCard({ product, priority = false }: { product: MainShopProduct; priority?: boolean }) {
  const { dictionary } = useDictionary();

  return (
    <Link
      href={`/shop/product/${product.id}/${product.slug}`}
      className="flex flex-col group"
    >
      <div className="relative aspect-square overflow-hidden rounded-xs">
        <Image
          src={product.thumbnail.url}
          alt={product.title}
          fill
          sizes="(max-width: 768px) 100vw, (max-width: 1200px) 33vw, 25vw"
          className="object-cover transition-transform duration-300 group-hover:scale-105"
          priority={priority}
        />
        {product.discount_percent > 0 && <Badge variant="destructive" className="absolute top-2 right-2 ltr:left-2 text-xs font-semibold rounded-full px-2.5 py-1 shadow-sm">
          {product.discount_percent}% {dictionary.ui?.cart.discount ?? 'تخفیف'}
        </Badge>}
      </div>

      <div className="p-2 space-y-2">
        <Heading level={3} className="text-xs">
          {product.title}
        </Heading>
        <div className="space-y-1">
          {product.discount_percent > 0 ? (
            <div className="flex items-center gap-2 flex-wrap">
              <span className="text-xs text-red-500 line-through">
                {formatPrice(Number(product.price))} {dictionary.ui.product.currency}
              </span>
              <span className="text-primary-600 text-xs">
                {formatPrice(Number(product.final_price))} {dictionary.ui.product.currency}
              </span>
            </div>
          ) : (
            <span className="text-primary-600 text-xs">
              {formatPrice(Number(product.price))} {dictionary.ui.product.currency}
            </span>
          )}
        </div>
        {!!product.product_colors && <div className="flex flex-wrap gap-3">
          {product.product_colors.map((color, index) => {
            const PackagingIcon = getPackagingIcon(color.color_title);
            return (
              <Tooltip key={index}>
                <TooltipTrigger asChild>
                  <span>
                    <div
                      className={`${PackagingIcon ? "size-6" : "size-4"} rounded-full border border-primary-300 cursor-pointer hover:ring-2 hover:ring-[#C6B8A3] transition-transform hover:scale-110 flex items-center justify-center`}
                      style={PackagingIcon ? undefined : { backgroundColor: color.color_code_hex }}
                      title={color.color_title}
                    >
                      {PackagingIcon && <PackagingIcon className="size-3.5 stroke-1 text-primary-900" />}
                    </div>
                  </span>
                </TooltipTrigger>
                <TooltipContent>
                  <p className="text-sm text-primary-0">{color.color_title}</p>
                </TooltipContent>
              </Tooltip>
            );
          })}
        </div>}
      </div>
    </Link>
  );
}